/* Minimal client-side glue. Most state is handled by Shopify form posts.
 * This file keeps the progressive-enhancement bits: variant picker
 * switching the URL/price, cart qty bumpers, and the hide-js-nothing helper.
 */
(function () {
  document.documentElement.classList.remove("no-js");

  // ---- Quantity bumpers (product + cart) ----
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-qty-step]");
    if (!btn) return;
    const wrap = btn.closest(".quantity");
    if (!wrap) return;
    const input = wrap.querySelector("input[type=number]");
    if (!input) return;
    const step = Number(btn.dataset.qtyStep || 1);
    const min = Number(input.min || 0);
    const next = Math.max(min, (Number(input.value) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // ---- Variant picker ----
  // On product pages we render a hidden JSON blob of variants. When the
  // shopper changes a radio the URL/price/availability update without a
  // full page reload; submitting the form still does the real POST to
  // /cart/add.
  const pickers = document.querySelectorAll("[data-variant-picker]");
  pickers.forEach((picker) => {
    const form = picker.closest("form");
    if (!form) return;
    const dataEl = picker.querySelector("[data-variants]");
    if (!dataEl) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    const idInput = form.querySelector("input[name=id]");
    const priceEl = document.querySelector("[data-product-price]");
    const submitBtn = form.querySelector("[data-add-to-cart]");

    function findMatch() {
      const selected = Array.from(picker.querySelectorAll("input[type=radio]:checked"))
        .map((r) => r.value);
      return variants.find((v) =>
        v.options.length === selected.length &&
        v.options.every((opt, i) => opt === selected[i])
      );
    }

    function update() {
      const match = findMatch();
      if (!match) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Unavailable"; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? "Add to cart" : "Sold out";
      }
      // Update URL for shareability without scrolling
      if (match.url) {
        const url = new URL(window.location);
        url.searchParams.set("variant", match.id);
        window.history.replaceState({}, "", url);
      }
    }

    picker.addEventListener("change", update);
    update();
  });
})();
